import React from 'react';
import { DatePicker } from '@3plearning/react-components';
import { t } from '@lingui/macro';
import Resources from '../../../helpers/resources';
import {
    REPORT_LEVEL_ALL_CLASSES,
    REPORT_LEVEL_SINGLE_CLASS,
    REPORT_LEVEL_GROUP,
    REPORT_LEVEL_STUDENT,
    SKILL_QUESTS_EXPORT_RESOURCE_METHODS,
    REPORT_EXPORTED
} from './export-report-actions';
import modalActions from '../../../containers/modal-container/modal-actions';

import activeFiltersSelectors from '../../report-filters/redux/active-filters/active-filters-selectors';
import skillQuestsMasteryStudentSelectors from '../../../containers/skill-quests-mastery/student/student-selectors';

import FormatPicker from '../format-picker/format-picker';
import { localeCode } from '../../../helpers/locale-helpers';

const SKILL_QUESTS_EXPORT_FILE_TYPE = {
    PDF: 0,
    EXCEL: 1
};

/**
 * Switch statement manages sub heading export click handler
 * @param reportLevel
 * @param dispatch
 * @param state
 * @param i18n
 */
export function exportSkillQuestsMasteryReport(
    reportLevel,
    dispatch,
    state,
    i18n
) {
    let resourceMethod = '';
    let path = {};

    const selectedDate = activeFiltersSelectors.selectDate(state);
    const assignmentResultType = state.assignmentResultType;
    const isCustomDate = selectedDate.type === DatePicker.CUSTOM_DATE;

    let query = {
        exportFileType: SKILL_QUESTS_EXPORT_FILE_TYPE.EXCEL,
        assignmentResultType,
        locale: localeCode()
    };

    switch (reportLevel) {
        case REPORT_LEVEL_ALL_CLASSES: {
            if (isCustomDate) {
                resourceMethod =
                    SKILL_QUESTS_EXPORT_RESOURCE_METHODS.CLASSROOM_CUSTOM_DATE;
                query = {
                    ...query,
                    startDate: selectedDate.startDate,
                    endDate: selectedDate.endDate
                };
            } else {
                resourceMethod = SKILL_QUESTS_EXPORT_RESOURCE_METHODS.CLASSROOM;
            }
            break;
        }
        case REPORT_LEVEL_SINGLE_CLASS:
        case REPORT_LEVEL_GROUP: {
            path = {
                classroomId: activeFiltersSelectors.selectClassId(state)
            };

            if (isCustomDate) {
                resourceMethod =
                    SKILL_QUESTS_EXPORT_RESOURCE_METHODS.GROUP_CUSTOM_DATE;
                query = {
                    ...query,
                    startDate: selectedDate.startDate,
                    endDate: selectedDate.endDate
                };
            } else {
                resourceMethod = SKILL_QUESTS_EXPORT_RESOURCE_METHODS.GROUP;
            }
            break;
        }
        case REPORT_LEVEL_STUDENT: {
            const {
                courseId,
                courseVersion
            } = skillQuestsMasteryStudentSelectors.selectCourseData(state);

            query = {
                ...query,
                courseId,
                courseVersion
            };
            path = {
                classroomId: activeFiltersSelectors.selectClassId(state),
                userProfileId: activeFiltersSelectors.selectStudent(state).id
            };

            if (isCustomDate) {
                resourceMethod =
                    SKILL_QUESTS_EXPORT_RESOURCE_METHODS.STUDENT_CUSTOM_DATE;
                query = {
                    ...query,
                    startDate: selectedDate.startDate,
                    endDate: selectedDate.endDate
                };
            } else {
                resourceMethod = SKILL_QUESTS_EXPORT_RESOURCE_METHODS.STUDENT;
            }

            break;
        }
        default:
            break;
    }
    const updateCallback = () =>
        getSkillQuestsReportData(resourceMethod, path, query);
    dispatch(
        modalActions.openModal(
            getAllClassesModalContent(dispatch, updateCallback, i18n)
        )
    );
}

function getAllClassesModalContent(dispatch, callback, i18n) {
    const text = {
        downloadText: i18n._(
            t(
                'Export - Download Skill Quests Mastery Report'
            )`Download Skill Quests Mastery Report`
        ),
        cancelText: i18n._(t('Export - Cancel')`Cancel`),
        exportText: i18n._(t('Export - Export')`Export`)
    };

    return {
        title: text.downloadText,
        content: <FormatPicker />,
        buttons: [
            {
                text: text.cancelText,
                danger: true,
                handler: () => dispatch(modalActions.closeModal())
            },
            {
                text: text.exportText,
                primary: true,
                handler: () => {
                    const action = callback();
                    if (action) {
                        dispatch(action);
                        dispatch(modalActions.closeModal());
                    }
                }
            }
        ]
    };
}

function getSkillQuestsReportData(resourceMethod, path, query) {
    return Resources[resourceMethod]
        .get(path)
        .withParams(query)
        .send()
        .then((payload) => {
            if (payload.valid) {
                const authToken = Resources.env.authToken;
                const updatedDownloadUrl = `${payload.verb.url}&authToken=${authToken}`;

                return {
                    type: REPORT_EXPORTED,
                    payload: {
                        downloadUrl: updatedDownloadUrl
                    }
                };
            }
            return null;
        });
}



// WEBPACK FOOTER //
// ./components/sub-heading/export-report/export-skill-quests-mastery-report.js